import { I18nMessage, withToggleState } from '@apoly-42/apoly-components';
import { withHandler } from '@apoly-42/apoly-utils';
import { ButtonWithIcon } from '@apoly-42/material-ui';
import {
  faCamera,
  faChevronDoubleRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Grid, Hidden, Toolbar, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import { compose } from 'recompose';
import { commonMessages } from '../../../../constants/messages/commonMessages';
import { flex, flexRight } from '../../../../constants/styles/commonClasses';
import { selectUser } from '../../../../redux/auth/reducer';
import {
  selectBasePath,
  selectEnhancedPharmacy,
  selectPharmacy,
} from '../../../../redux/shopPharmacy/reducer';
import {
  partnerPharmacyPath,
  submitPrescriptionPath,
} from '../../../../routes/paths';
import ShoppingCartButton from '../../../shoppingCartButton/ShoppingCartButton';
import RightDrawerSetPharmacy from '../drawer/RightDrawerSetPharmacy';
import SubNavBar from '../subNavbar/SubNavBar';
import UserMenuForTabbar from '../userMenu/UserMenuForTabbar';
import BrandName from './navBarComponents/BrandName';
import FindMedicButton from './navBarComponents/FindMedicButton';
import ToggleDrawerButton from './navBarComponents/ToggleDrawerButton';
import SearchBar from './SearchBar';

const styles = theme => ({
  flexAndFlexRight: {
    ...flexRight,
    ...flex,
  },
  fixedDoubleNavbarHeight: {
    height: 56 * 2,
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      height: 48 * 2,
    },
    [theme.breakpoints.up('sm')]: {
      height: 64 * 2,
    },
  },
});

const InnerNavBarSetPharmacyView = ({
  searchBarOpen,
  toggleSearchBar,
  drawerOpen,
  toggleDrawer,
  classes,
  toggleSearchBarAndDrawer,
  enhancedPharmacy,
  basePath,
  pharmacy,
  onEnter,
  user,
  logOutUser,
  logOut,
  intl: { formatMessage },
}) => (
  <div className={classes.fixedDoubleNavbarHeight}>
    <AppBar position="static">
      <Grid container justify="center" spacing={0}>
        <Grid item xs={12} lg={10} style={{ flexGrow: 1 }}>
          <Toolbar>
            <BrandName url={partnerPharmacyPath(basePath)} />
            <div style={flex}>
              <FindMedicButton
                toggleSearchBar={toggleSearchBar}
                disabled={searchBarOpen}
              />
              <Hidden smDown>
                <ButtonWithIcon
                  color="inherit"
                  icon={faCamera}
                  component={Link}
                  aria-label={formatMessage(commonMessages.submitPrescription)}
                  to={submitPrescriptionPath(basePath)}
                >
                  <span>
                    <I18nMessage message={commonMessages.submitPrescription} />
                    &nbsp;
                    <FontAwesomeIcon icon={faChevronDoubleRight} />
                  </span>
                </ButtonWithIcon>
              </Hidden>
              <ShoppingCartButton />
              {user && <UserMenuForTabbar logOut={logOut} />}
              <ToggleDrawerButton toggleDrawer={toggleDrawer} />
            </div>
          </Toolbar>
        </Grid>
        <Grid item xs={12} lg={10}>
          <SubNavBar enhancedPharmacy={enhancedPharmacy} pharmacy={pharmacy} />
        </Grid>
      </Grid>
    </AppBar>
    <RightDrawerSetPharmacy
      open={drawerOpen}
      toggleSearchBarAndDrawer={toggleSearchBarAndDrawer}
      handleDrawer={toggleDrawer}
      logOutUser={logOutUser}
      pharmacy={pharmacy}
      basePath={basePath}
      enhancedPharmacy={enhancedPharmacy}
    />
    <SearchBar
      onEnter={onEnter}
      pharmacy={pharmacy}
      open={searchBarOpen}
      closeSearchBar={toggleSearchBar}
    />
  </div>
);

const mapStateToProps = state => ({
  user: selectUser(state),
  basePath: selectBasePath(state),
  pharmacy: selectPharmacy(state),
  enhancedPharmacy: selectEnhancedPharmacy(state),
});

const enhance = compose(
  withToggleState('drawerOpen', 'toggleDrawer', false),
  withToggleState('searchBarOpen', 'toggleSearchBar', false),
  withHandler('logOutUser', props => () => [
    props.toggleDrawer(),
    props.logOut(),
  ]),
  withHandler('toggleSearchBarAndDrawer', props => () => [
    props.toggleDrawer(),
    props.toggleSearchBar(),
  ]),
  withStyles(styles),
  injectIntl,
  connect(mapStateToProps)
);

const NavBarSetPharmacyView = enhance(InnerNavBarSetPharmacyView);

NavBarSetPharmacyView.propTypes = {
  logOut: PropTypes.func.isRequired,
};

InnerNavBarSetPharmacyView.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  pharmacy: PropTypes.object.isRequired,
  basePath: PropTypes.string.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  searchBarOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  toggleSearchBar: PropTypes.func.isRequired,
  toggleSearchBarAndDrawer: PropTypes.func.isRequired,
  enhancedPharmacy: PropTypes.object,
  user: PropTypes.object,
  logOutUser: PropTypes.func.isRequired,
  ...NavBarSetPharmacyView.propTypes,
};

InnerNavBarSetPharmacyView.defaultProps = {
  user: null,
  enhancedPharmacy: null,
  ...NavBarSetPharmacyView.defaultProps,
};

export default NavBarSetPharmacyView;
